import React from "react";
import TextField from "../../../../Forms/TextField";
import { MultiDatePicker } from "../../../../Forms/DatePicker";

const BasicInfoFields = () => {
  return (
    <>
      <TextField
        label="Title"
        name="title"
        required
      />
      <TextField
        label="Sponsor Name"
        name="sponsor"
        required
      />
      <TextField
        label="URL"
        name="url"
        required
      />

      <MultiDatePicker
          label="Application Date (MM/DD)"
          name="datesAwarded"
          formatStr="MM/dd"
          required
      />
     
      <TextField label="Verified Year" name="verifiedYear" required />
      <TextField label="Audit Notes" name="auditNotes" />
    </>
  );
};

export default BasicInfoFields;
